import { element, noop } from 'angular';
export var StickyDirective = [
    'cartChannel',
    function (cartChannel) {
        return {
            link: function ($scope, $element) {
                var summaryBoxHolder = element('.solution-summary-box__holder', $element.parent());
                var containerSelector = '.solution-summary-box__container';
                var container = summaryBoxHolder.find(containerSelector);
                var refreshSummaryBox = function () {
                    container.trigger('sticky_kit:recalc');
                };
                var isLoaded = false;
                cartChannel.onAdd().then(noop, noop, refreshSummaryBox);
                cartChannel.onRemove().then(noop, noop, refreshSummaryBox);
                $scope.$watch('setStickyOn', function (setStickyOn) {
                    if (!setStickyOn || isLoaded) {
                        return;
                    }
                    isLoaded = true;
                    container.stick_in_parent();
                    refreshSummaryBox();
                });
                $scope.$on('$destroy', function () {
                    container.trigger('sticky_kit:detach');
                    summaryBoxHolder.empty();
                });
            },
            restrict: 'A',
            scope: {
                setStickyOn: '<',
            },
        };
    },
];
